import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Loader from '../../../../Components/Spinner/Loader';
import PostDataApis from '../../../../Components/Common/FetchData/PostDataApis';
import { Button } from 'react-bootstrap';
import InputField from '../../../../Components/Common/InputField';
import SelectTextArea from '../../../../Components/Common/SelectTextArea';

const CreateMyLead = ({
  setToggle,
}: {
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const { postData, loading, success } = PostDataApis(
    `/api/fair/exhibitor/lead`
  );

  useEffect(() => {
    if (success) {
      setToggle(false);
      reset();
    }
  }, [success]);
  const onSubmit = async (data: any) => {
    postData(data);
  };
  return (
    <div>
      <div className='col-md-12 mb-4 mt-3'>
        <div className='front-card '>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='row'>
              <div className='form-group col-xs-12 col-md-6'>
                <InputField
                  label='Name'
                  isRequired
                  register={register('name')}
                />
              </div>
              <div className='form-group col-xs-12 col-md-6'>
                <InputField
                  label='Email'
                  isRequired
                  register={register('email')}
                  type={'email'}
                />
              </div>
              <div className='form-group col-xs-12 col-md-6'>
                <InputField
                  label='Phone'
                  isRequired
                  register={register('phone')}
                  type={'number'}
                />
              </div>

              <div className='form-group col-xs-12 col-md-6'>
                <SelectTextArea
                  label='Address'
                  register={register('address')}
                  rows={2}
                  isRequired
                />
              </div>
              <div className='form-group col-xs-12 col-md-12'>
                <SelectTextArea
                  label='Customer Interest'
                  register={register('details')}
                  isRequired
                  rows={2}
                />
              </div>

              <div className='form-group col-md-12 mt-3 text-end'>
                {loading ? (
                  <Loader css={'btn'} />
                ) : (
                  <Button type='submit' className='submit-button'>
                    Create Lead
                  </Button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateMyLead;
